import styled, { keyframes, css } from "styled-components";

const STRIPE_WIDTH = "57px";
const animateButtonPendingBackground = keyframes`
  0% {
		transform: translateX(-${STRIPE_WIDTH});
	}
	100% {
		transform: translateX(0);
	}
`;

const scroll = keyframes`
    0% {
        -webkit-transform: translate(00%, 0);
        transform: translate(0%, 0);
    }
    100% {
        -webkit-transform: translate(-100%, 0);
        transform: translate(-100%, 0)
    }
`;

const rotate = keyframes`
  0% {
    transform:  translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform:  translate(-50%, -50%) rotate(-360deg);
  }
`;

const textOpacity = keyframes`
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

export const pendingStyles = css`
  .pending-div {
    position: absolute;
  }
  &.pending {
    position: relative;
    pointer-events: none;
    overflow: hidden;
    box-shadow: none;
    z-index: 4;
    transform: translateZ(0);

    .pending-div {
      display: block;
      top: 0;
      left: 0;
      height: 100%;
      width: calc(100% + ${STRIPE_WIDTH});
      background: repeating-linear-gradient(
        -45deg,
        #f7f4f3 25%,
        #f7f4f3 50%,
        #ffffff 50%,
        #ffffff 75%
      );
      background-size: ${STRIPE_WIDTH} ${STRIPE_WIDTH};
      animation: ${animateButtonPendingBackground} 1.5s linear infinite;
      z-index: 8;
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  font-family: "PlusJakartaSans", "Medium", sans-serif;
  p,
  div,
  a,
  h1,
  h2,
  h3,
  button {
    font-family: "PlusJakartaSans", "Medium", sans-serif;
  }

  .action,
  .headerM,
  .headerS,
  .headerL {
    font-weight: 400;
    font-variation-settings: "wght" 700;
  }

  &.overflow {
    overflow: hidden;
    max-height: 100vh;
    max-height: 100dvh;
  }
  &.mint {
    background: #99ffee;
  }
  &.sand {
    background: #fcfdc7;
  }

  &.dark {
    background: #11140c;
    p,
    div,
    h1,
    h2,
    h3 {
      color: var(--text-primary, #faf8f7);
    }
    .secondary {
      color: var(--text-secondary-on-dark, rgba(242, 237, 235, 0.48));
    }
  }

  .slick-slide {
    opacity: 0.15;
    transition: opacity 700ms ease-out;
    // width: calc(200% + 40px);
    & > div {
      // margin: 0 20px;
    }
  }

  .slick-current {
    opacity: 1;
  }

  .hide-desktop {
    display: none;
    @media (max-width: 1024px) {
      display: block;
    }
  }

  @media (max-width: 1024px) {
    .hide-mobile {
      display: none;
    }
  }

  .slick-track {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
`;

export const Container = styled.div`
  box-sizing: border-box;
  width: 1204px;
  width: 1232px;
  max-width: 100%;
  padding: 0 24px;
  position: relative;
  margin: 0 auto;
  @media (min-width: 1919px) {
    width: 1632px;
  }
  @media (max-width: 1025px) {
    width: 886px;
  }
`;

export const Welcome = styled.div`
  padding-top: 176px;
  position: relative;
  .zigzag {
    right: 0;
    top: 0;
    height: 100%;
    width: auto;
    position: absolute;
    object-fit: contain;
    z-index: 0;
  }

  ${Container} {
    z-index: 2;
  }
  @media (max-width: 769px) {
    padding-top: 82px;
    .zigzag {
      height: calc(100% - 150px);
      top: 75px;
      right: -160px;
    }
  }
`;

export const GridWelcome = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "title form"
    "buttons form";

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const Subtext = styled.div`
  letter-spacing: 0.01em;
  color: #72706e;
  &.centered {
    text-align: center;
  }
  &.sm {
    font-size: 12px;
  }
`;

export const Nobr = styled.span`
  white-space: nowrap;
`;

export const TitleWelcome = styled.h1`
  font-size: 64px;
  line-height: 80px;
  letter-spacing: 0.96px;
  color: #000000;
  grid-area: title;
  margin: 0;
  max-width: 450px;
  font-variation-settings: "wght" 700;
  font-style: normal;
  font-weight: normal;
  text-shadow: 0 0 0;
  margin-top: -24px;

  ${Nobr} {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  @media (max-width: 769px) {
    font-size: 48px;
    line-height: 56px;
    max-width: 100%;
    width: 100%;
    margin-top: 0;
  }
`;

export const WelcomeFormBlock = styled.div`
  border: 0;
  outline: 0;
  text-decoration: none;
  cursor: pointer;
  text-align: center;
  background: #99ffee;
  border-radius: 32px;
  padding: 24px;
  width: 448px;
  margin: 0 0 0 auto;
  grid-area: form;
  transition: 300ms ease-out;
  box-shadow: 0px 8px 24px 0px rgba(0, 178, 163, 0.24),
    0px 4px 8px 0px rgba(0, 178, 163, 0.12);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-items: flex-end;
  font-family: "PlusJakartaSans", sans-serif;
  min-height: 336px;

  .bgr {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
    display: block;
    z-index: 0;
    &--mobile {
      display: none;
    }
  }
  & > * {
    position: relative;
    z-index: 3;
  }
  @media (min-width: 1920px) {
    width: 580px;
  }

  @media (max-width: 1024px) {
    width: 100%;
    margin: 0 auto 0;

    .bgr {
      display: none;
      &--mobile {
        display: block;
      }
    }
  }
`;

export const FormTitleBlock = styled.div`
  margin: auto 0;
`;
export const FormTitle = styled.div`
  color: #000;
  font-size: 32px;
  font-style: normal;
  line-height: 40px;
  font-weight: 400;
  font-variation-settings: "wght" 700;
`;
export const FormSubitle = styled.div`
  letter-spacing: 0.16px;
`;

export const FormasButton = styled.button`
  border: 0;
  outline: 0;
  box-shadow: 0px 4px 8px 0px rgba(51, 20, 0, 0.08),
    0px 2px 1px 0px rgba(51, 20, 0, 0.04);
  border-radius: 8px;
  background: #fff;
  padding: 14px;
  width: 100%;
  color: #000;
  letter-spacing: 0.48px;
  font-weight: 400;
  font-variation-settings: "wght" 700;
  display: block;
  cursor: pointer;
  text-decoration: none;
  transition: 300ms ease-out;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #f8f7f6;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const NetworkBadge = styled.div`
  backdrop-filter: blur(12px);
  background: rgba(204, 187, 184, 0.16);
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 32px;
  gap: 4px;
  padding: 4px 12px 4px 12px;
  font-variation-settings: "wght" 600;
  margin: 0 auto;
  letter-spacing: 0.32px;

  img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }
`;

export const ManageParticipation = styled.div`
  border: 0;
  outline: 0;
  background: transparent;
  display: flex;
  font-variation-settings: "wght" 700;
  letter-spacing: 0.48px;
  gap: 8px;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  transition: 300ms ease-out;
  padding: 12px;
  text-decoration: none;
  &.single {
    background: #ffffff;
  }
  &:hover {
    background: #f8f7f6;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const Marquee = styled.div`
  display: block;
  width: 360px;
  overflow: hidden;
  background: #99ffee;
  border-radius: 40px;
  height: 80px;
  span {
    display: inline-block;
    height: 80px;
    box-sizing: border-box;
    top: 0;
    animation: ${scroll} 8s infinite linear;
    padding-right: 20px;
  }

  .unit {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    & + .unit {
      margin-left: 24px;
    }
  }
  @media (max-width: 769px) {
    height: 56px;
  }
`;

export const ButtonsWelcome = styled.div`
  grid-area: buttons;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  @media (max-width: 1025px) {
    margin-top: 64px;
  }
  @media (max-width: 769px) {
    margin-top: 8px;
  }
`;

export const ButtonsWelcomeRow = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
  & > * {
    flex: 0 1 186px;
  }
  @media (max-width: 1024px) {
    justify-content: center;
    & > * {
      flex: 1 1 50%;
    }
  }
  @media (max-width: 580px) {
    flex-direction: column;
    gap: 6px;
    & > * {
      flex: 1 1 100%;
    }
  }
`;

export const Button = styled.button`
  background: #000000;
  border-radius: 16px;
  width: 100%;
  font-variation-settings: "wght" 700;
  height: 64px;
  letter-spacing: 0.03em;
  color: #ffffff;
  border: 0;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;

  &.secondary {
    background: #f7f3f2;
    color: #000000;
  }

  &.link {
    background: transparent;
    color: #000000;
  }

  &.sm {
    padding: 4px 12px;
    height: 32px;
    width: fit-content;
  }

  &:hover {
    background: #3a3836;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const LinkButton = styled.a`
  border-radius: 16px;
  width: 100%;
  font-variation-settings: "wght" 700;
  height: 64px;
  min-height: 64px;
  letter-spacing: 0.03em;
  border: 0;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: 300ms ease-out;
  background: #f7f3f2;
  color: #000000;

  &:hover {
    background: #ebe7e5;
  }
  &:active {
    transform: scale(0.95);
  }

  &.black {
    background: #000;
    color: #fff;
    &:hover {
      background: #3a3836;
    }
  }

  &.transparent {
    background: transparent;
    &:hover {
      background: #f8f7f6;
    }
  }
`;

export const CardsRow = styled.div`
  display: flex;
  margin: 0 4px;
  & > * {
    margin: 0 -4px;
    flex: 1 1 33%;
  }

  @media (max-width: 769px) {
    flex-direction: column;
    margin: 0;
    & > * {
      margin: 0;
      flex: 1 1 auto;
    }
  }
`;

export const MainCard = styled.div`
  background: #defffa;
  border-radius: 24px;
  padding: 28px 16px 28px 24px;
  display: flex;
  /* isolation: isolate; */
  mix-blend-mode: multiply;
  justify-content: space-between;
  @media (max-width: 769px) {
    & + & {
      margin-top: -8px;
    }
  }
`;

export const MainCardIcon = styled.div`
  background: #99ffee;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  margin-top: -12px;
`;

export const MainCardTitle = styled.div`
  letter-spacing: 0.02em;
  font-size: 20px;
  line-height: 24px;
  font-variation-settings: "wght" 700;
`;

export const MainCardText = styled.div`
  letter-spacing: 0.01em;
  margin-top: 8px;
  color: #72706e;
`;

export const DecentralizedRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  max-width: 980px;
  margin-left: auto;
  @media (max-width: 769px) {
    display: flex;
    gap: 8px;
  }
`;

export const Header = styled.h2`
  margin: 0;
  font-size: 32px;
  letter-spacing: 0.32px;
  color: #000000;
  font-variation-settings: "wght" 700;
  text-shadow: 0 0 0;
  font-style: normal;
  font-weight: normal;
  text-shadow: 0 0 0;
  line-height: 40px;

  svg {
    vertical-align: bottom;
  }
  &.center {
    text-align: center;
  }
  &.developers {
    text-align: center;
    @media (max-width: 769px) {
      text-align: left;
    }
  }
  @media (min-width: 1024px) {
    font-size: 40px;
    line-height: 48px;
    letter-spacing: normal;
  }
`;

export const DecentralizedBlock = styled.div`
  display: grid;
  grid-template-columns: 424px 1fr;
  gap: 44px;
  ${Header} {
    margin-top: 8px;
  }
  @media (min-width: 1919px) {
    grid-template-columns: 608px 1fr;
  }
  @media (max-width: 1025px) {
    grid-template-columns: 310px 1fr;
  }
  @media (max-width: 769px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const DecentralizedCard = styled.div`
  background: #f7f3f2;
  border-radius: 24px;
  padding: 24px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 320px;
  overflow: hidden;
  gap: 24px;
  .secondary {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.5px;
    color: #72706e;
  }
  .time {
    width: 64px;
    height: 64px;
  }

  &.hide-desktop {
    display: none;
  }
  @media (max-width: 769px) {
    min-width: 160px;
    width: 160px;
    height: 192px;
    &.hide-desktop {
      background: transparent;
      display: flex;
    }
    &.empty {
      min-width: 12px;
      max-width: 12px;
      padding: 0;
    }
  }
`;

export const DecentralizedComing = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  .secondary {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.5px;
    color: #72706e;
  }
`;

export const GraphiksScroll = styled.div`
  max-width: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar:horizontal {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 34px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 24px !important;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }

  @media (max-width: 769px) {
    padding-bottom: 12px;
    margin-right: -24px;
    margin-left: -24px;
    width: calc(100% + 48px);
    max-width: calc(100% + 48px);
  }
`;

export const NetworkIconSoon = styled.div`
  background: #efe8e6;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const BetterRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  @media (max-width: 769px) {
    grid-template-columns: 1fr;
  }
`;

export const BetterCard = styled.div`
  position: relative;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0px 4px 8px rgba(51, 20, 0, 0.04),
    0px 8px 24px rgba(51, 20, 0, 0.08);
  border-radius: 32px;
  padding: 24px;
  height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > * {
    position: relative;
    z-index: 4;
  }
  @media (max-width: 1025px) {
    padding: 24px 14px;
  }
  @media (max-width: 769px) {
    padding: 24px;
  }
`;

export const BetterHeading = styled.div`
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.02em;
  font-variation-settings: "wght" 700;
  @media (max-width: 1025px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
  }
`;

export const AnimatedText = styled.div`
  margin: 0 auto;
  width: fit-content;
  transform: translateY(-20px);
  position: relative;

  #gradient {
    width: 172px;
    height: 172px;
  }
  .clip {
    width: 192px;
    height: 200px;
  }

  .grad {
    background: #000;
    width: 100%;
    height: 100%;
    transform-origin: 50%;
    position: absolute;
    position: relative;
    mask-image: url("/contest/images/msk.svg");
    -webkit-mask-image: url("/contest/images/msk.svg");
    width: 196px;
    height: 200px;

    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 130%;
      height: 130%;
      content: "";
      background: conic-gradient(
        from 105deg at 50% 50%,
        #99ffee 0deg,
        rgba(0, 0, 0, 1) 360deg
      );
      transform-origin: 50% 50%;
      animation: ${rotate} 2s linear infinite;
    }
  }

  .foreign {
    overflow: visible;
    transform: translate(10px, 10px);
    width: 100%;
    height: 100%;
  }
`;

export const AnimatedTextInner = styled.div`
  background: #defffa;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, calc(-50% - 6px));
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  .contens {
    width: 64px;
    height: 64px;
    object-fit: contain;
    object-position: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    animation: ${textOpacity} 2s ease-in-out infinite alternate;
    &:nth-child(2) {
      animation-delay: 2s;
    }
  }
`;

export const FlexibleCircle = styled.div`
  width: 96px;
  height: 96px;
  position: absolute;
  left: 50%;
  margin-top: 66px;
  transform: translate(-50%, 0);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-variation-settings: "wght" 700;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #000000;
  transition: 300ms ease-out;
  z-index: 0;
  .circle {
    position: absolute;
    z-index: -1;
    width: 96px;
    height: 96px;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    transition: 300ms ease-out;
    background: #99ffee;
    transform: translate(-50%, -50%);
    min-width: 96px;
    min-height: 96px;
  }

  &::after {
    content: "APR";
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.5px;
    color: #72706e;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 100%);
    bottom: -8px;
    z-index: 2;
    font-variation-settings: "wght" 500;
  }
  .animated {
    width: 620px;
    height: 620px;
  }
  @media (max-width: 769px) {
    .animated {
      width: 200vw;
      height: 200vw;
    }
  }
`;

export const LongShort = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 14px;
  transition: 1600ms cubic-bezier(0.68, -0.28, 0.12, 1.25);
  margin: 78px auto auto;
  transform: rotate(-34deg);
  transform-origin: top center;
  .long {
    font-variation-settings: "wght" 700;
    font-size: 16px;
    line-height: 1;
    transition: 1600ms cubic-bezier(0.68, -0.28, 0.12, 1.25);
  }
  .short {
    font-variation-settings: "wght" 700;
    transition: 1600ms cubic-bezier(0.68, -0.28, 0.12, 1.25);
    font-size: 31px;
    line-height: 1;
  }
  &.animated {
    transform: rotate(34deg);
    .long {
      font-size: 31px;
    }
    .short {
      font-size: 16px;
    }
  }
  @media (max-width: 1025px) {
    gap: 4px;
    img {
      width: 114px;
      object-fit: contain;
    }
  }
`;

export const LongShortButton = styled.button`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  cursor: pointer;
  border: 0;
  outline: 0;
  position: absolute;
  right: 76px;
  bottom: 48px;
  background: transparent;
  transition: 900ms cubic-bezier(0.27, -0.38, 0.74, 1.38);
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  &.animated {
    right: calc(100% - 47px);
    transform: translateX(100%);
  }
  @media (max-width: 1025px) {
    right: 20px;
    &.animated {
      right: calc(100% - 20px);
    }
  }
`;

export const PartyRadio = styled.div`
  margin: 15px auto auto;
  background: #efe8e6;
  border-radius: 18px;
  width: 56px;
  height: 36px;
  position: relative;
  transition: 300ms ease-out;
  .trigger {
    border: 0;
    outline: 0;
    position: absolute;
    top: 2px;
    left: 2px;
    bottom: 2px;
    width: 32px;
    height: 32px;
    box-shadow: 0px 2px 1px rgba(51, 20, 0, 0.04),
      0px 4px 8px rgba(51, 20, 0, 0.08);
    border-radius: 50px;
    cursor: pointer;
    transition: 300ms ease-out;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &.animated {
    background: #99ffee;
    .trigger {
      left: calc(100% - 2px);
      transform: translateX(-100%);
    }
  }
`;

export const PartyBlockTop = styled.div`
  border-radius: 12px;
  background: #e7ddda;
  padding: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  transition: 300ms ease-out;
  opacity: 0.7;
  color: #b0adab;
`;

export const PartyPlash = styled.div`
  padding: 6px 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f7f3f2;
  border-radius: 4px;
  transition: 300ms ease-out;
`;

export const PartyAside = styled.div`
  position: absolute;
  right: 0;
  right: 24px;
  top: 16px;
  transition: 300ms ease-out;
  opacity: 0;
  &.visible {
    opacity: 1;
  }
`;

export const PartyValue = styled.div`
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  letter-spacing: 0.02em;
  font-variation-settings: "wght" 700;
  color: #b0adab;
`;

export const PartyDollars = styled.div`
  font-size: 9px;
  line-height: 12px;
  text-align: right;
  letter-spacing: 0.375px;
  color: #72706e;
`;

export const PartyBottom = styled(PartyBlockTop)`
  margin-top: 6px;
  &::after {
    position: absolute;
    content: " ";
    left: 50%;
    top: 0;
    transform: translate(-50%, calc(-50% - 4px));
    background-image: url("data:image/svg+xml,%3Csvg width='26' height='24' viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' width='25.5' height='24' rx='12' fill='%23DEFFFA'/%3E%3Cmask id='mask0_1409_102386' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='5' y='5' width='16' height='14'%3E%3Cg clip-path='url(%23clip0_1409_102386)'%3E%3Cpath opacity='0.8' fill-rule='evenodd' clip-rule='evenodd' d='M5.75 15.75L8.75 18.75H10.25L13.25 15.75L12.125 14.625L10.25 16.5V5.25H8.75V16.5L6.875 14.625L5.75 15.75Z' fill='black'/%3E%3Cpath opacity='0.4' fill-rule='evenodd' clip-rule='evenodd' d='M16.25 5.25L13.25 8.25L14.375 9.375L16.25 7.5L16.25 18.75H17.75L17.75 7.5L19.625 9.375L20.75 8.25L17.75 5.25H16.25Z' fill='black'/%3E%3C/g%3E%3C/mask%3E%3Cg mask='url(%23mask0_1409_102386)'%3E%3Crect x='4.25' y='3' width='18' height='18' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1409_102386'%3E%3Crect width='15' height='13.5' fill='white' transform='translate(5.75 5.25)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    width: 24px;
    height: 24px;
    background-size: contain;
    background-repeat: no-repeat;
    filter: grayscale(1);
  }
`;

export const PartyBlock = styled.div`
  background: #efe8e6;
  border-radius: 24px 24px 24px 24px;
  margin: auto auto -24px;
  padding: 16px;
  width: 100%;
  transition: 300ms ease-out;
  filter: grayscale(0);
  &.colored {
    background: #ffffff;
    ${PartyBlockTop} {
      background: #f7f3f2;
    }
    ${PartyPlash} {
      background: #fff;
      color: #000;
    }
    ${PartyValue} {
      color: #000;
    }
    ${PartyBottom} {
      background: #defffa;
      &::after {
        filter: grayscale(0);
      }
    }
  }
`;

export const LeveragePlash = styled.div`
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 2px;
  font-size: 9px;
  line-height: 12px;
  letter-spacing: 0.375px;
  color: #000000;
`;

export const JoinToLearn = styled.a`
  border: 0;
  outline: 0;
  background: transparent;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  letter-spacing: 0.03em;
  color: #000000;
  font-variation-settings: "wght" 700;
  border-radius: 16px;
  height: 64px;
  width: fit-content;
  padding: 0 34px;
  transition: 200ms ease-in;
  &:hover {
    background: #f8f7f6;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const DevelopersContainer = styled.div`
  max-width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    gap: 8px;
    width: 100%;
  }
  @media (max-width: 769px) {
    max-width: none;
    margin: 0;
    display: flex;
  }
`;

export const DevScrollContainer = styled.div`
  overflow-x: scroll;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar:horizontal {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 34px;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 24px !important;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }

  @media (max-width: 769px) {
    padding-bottom: 12px;
    margin-right: -24px;
    margin-left: -24px;
    width: calc(100% + 48px);
    max-width: calc(100% + 48px);
  }
`;

export const DevCard = styled.div`
  border-radius: 32px;
  background: #f7f3f2;
  padding: 28px 24px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 769px) {
    width: calc(100vw - 68px);
    min-width: 342px;
  }
`;

export const DevUnit = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 8px 0;
  letter-spacing: 0.01em;
`;

export const DevCardTitle = styled.div`
  font-variation-settings: "wght" 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #000000;
  margin-bottom: 14px;
  &.center {
    text-align: center;
  }
`;

export const DevIcon = styled(NetworkIconSoon)`
  width: 48px;
  height: 48px;
  margin-bottom: 0;
`;

export const FooterWrapper = styled.footer`
  padding: 24px 24px 48px 24px;
  border-radius: 56px 56px 0px 0px;
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));

  @media (max-width: 769px) {
    margin: 0 -24px;
  }
`;

export const FooterTemp = styled.footer`
  display: none;
  background: #99ffee;
  border-radius: 32px 32px 0px 0px;
  padding: 24px 24px 48px;
  @media (max-width: 769px) {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const FooterTempButton = styled.a`
  background: #000000;
  text-decoration: none;
  border-radius: 16px;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
  color: #ffffff;
  font-variation-settings: "wght" 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: 50% 50%;
  padding: 16px;
  height: 64px;
  transition: 200ms ease-out;
  gap: 8px;
  &:active {
    transform: scale(0.95);
  }
  &.twitter {
    background: transparent;
    color: #000000;
  }
`;

export const FormBlock = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  color: #fff;
  gap: 8px;
  position: relative;

  .pseudo {
    top: 12px;
    left: 16px;
    position: absolute;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.5px;
    color: #72706e;
    transition: 300ms ease-out;
    opacity: 1;
    z-index: 0;
  }
`;

export const WelcomeInput = styled.input`
  background: #3a3836;
  border-radius: 16px;
  color: #fff;
  height: 64px;
  border: 0;
  outline: 0;
  padding: 18px 16px;
  width: 100%;
  display: block;
  font-size: 16px;
  line-height: 24px;
  font-family: "PlusJakartaSans", sans-serif;
  letter-spacing: 0.01em;
  border: 2px solid transparent;
  transition: 300ms ease-out;
  z-index: 2;

  &::placeholder {
    color: #b0adab;
  }

  &:focus {
    border: 2px solid #ffffff;
    background: transparent;
    padding: 28px 16px 12px;
    &::placeholder {
      opacity: 0;
    }

    &::before {
      opacity: 1;
    }
  }

  &.error {
    background: #3a3836;
    border: 1px solid #e64595;
    &:focus {
      border: 2px solid #e64595;
      background: transparent;
    }
  }
`;

export const FormButton = styled.button`
  height: 64px;
  width: 64px;
  padding: 6px;
  background: #99ffee;
  border-radius: 16px;
  border: 0;
  outline: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 64px;
  position: relative;
  z-index: 1;
  transition: 200ms ease-out;

  &:hover {
    background: #5cffde;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 769px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 34px;
  }
`;

export const FooterSocials = styled.div`
  display: flex;
  gap: 8px;
`;

export const FooterLinks = styled.div`
  gap: 32px 64px;
  padding-right: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  button,
  a {
    text-decoration: none;
    letter-spacing: 0.01em;
    border: 0;
    outline: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
    display: flex;
    gap: 4px;
    align-items: center;
    color: var(--text-secondary);
  }
  @media (max-width: 769px) {
    display: flex;
    flex-direction: column;
    gap: 28px;
    align-items: flex-start;
    a {
      padding: 0;
    }
  }
`;

export const FooterSocialButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  padding: 2px;
  border-radius: 8px;
  transition: 300ms ease-out;
  border-radius: var(--rounding-radius-m, 16px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  backdrop-filter: blur(12px);
  img,
  svg {
    filter: invert(1);
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  &:hover {
    background: var(--fill-secondary-hover, rgba(140, 129, 126, 0.48));
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const FooterEqLink = styled.a`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  color: #000;
  width: fit-content;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #94f3e2;
    transition: 300ms ease-out;
    width: 48px;
    height: 48px;
    border-radius: 8px;
  }
  &:hover .icon {
    mix-blend-mode: multiply;
  }
  &:active .icon {
    transform: scale(0.95);
  }
`;

export const SignIn = styled.button`
  display: flex;
  background: transparent;
  border: 0;
  outline: 0;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  position: relative;
  @media (max-width: 769px) {
    position: static;
  }
`;

export const SignInEth = styled.div`
  background: #defffa;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SignInBtn = styled.div`
  border-radius: 16px;
  background: rgba(239, 232, 230, 0.3);
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
  color: #000000;
  font-variation-settings: "wght" 700;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  transition: 300ms ease-out;
`;

export const PageHeader = styled.header`
  position: fixed;
  padding: 14px 22px 13px;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  transition: 300ms ease-out;
  &.scrolled {
    background: #f7f3f2;
    ${SignInBtn} {
      background: rgba(239, 232, 230, 1);
    }
  }
  .homelink {
    display: flex;
  }
`;

export const PageHeaderRight = styled.div`
  display: flex;
  gap: 8px;
`;

export const LeaderboardLink = styled.a`
  box-shadow: 0px 4px 8px 0px rgba(51, 20, 0, 0.08),
    0px 2px 1px 0px rgba(51, 20, 0, 0.04);
  border-radius: 16px;
  background: #fff;
  padding: 4px 9px;
  gap: 4px;
  display: flex;
  align-items: center;
  letter-spacing: 0.48px;
  color: #000000;
  text-decoration: none;
  font-variation-settings: "wght" 700;
  cursor: pointer;
  transition: 300ms ease-out;
  &:active,
  &:focused {
    color: #000000;
  }
  &:hover {
    background: #f8f7f6;
  }
`;

export const GoToAppLink = styled.button`
  border: 0;
  outline: 0;
  border-radius: 16px;
  background: #f7f3f2;
  mix-blend-mode: multiply;
  height: 32px;
  cursor: pointer;
  letter-spacing: 0.48px;
  font-variation-settings: "wght" 700;
  padding: 5px 12px;
  &:hover {
    background: #ebe7e5;
  }
  &:active {
    transform: scale(0.95);
  }
`;

export const ChooseNwLayer = styled.div`
  width: 320px;
  position: absolute;
  right: 30px;
  bottom: -10px;
  transform: translate(0, 100%);
  display: none;
  &.visible {
    display: block;
  }

  @media (max-width: 769px) {
    backdrop-filter: blur(8px);
    background: rgba(247, 243, 242, 0.76);
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translate(0, 0);
  }
`;

export const ChooseNwBody = styled.div`
  background: #ffffff;
  box-shadow: 0px 8px 32px rgba(51, 20, 0, 0.16);
  border-radius: 32px;
  width: 100%;
  padding: 28px 24px 16px;
  @media (max-width: 769px) {
    left: 8px;
    bottom: 0;
    right: 0;
    max-width: calc(100% - 16px);
    position: absolute;
  }
`;

export const ChooseNwTitle = styled.div`
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.02em;
  color: #000000;
  font-variation-settings: "wght" 700;
  margin-bottom: 12px;
  text-align: left;
  @media (max-width: 769px) {
    text-align: center;
  }
`;

export const ChooseNwItem = styled.div`
  display: flex;
  gap: 16px;
  padding: 8px 0;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-align: left;
  .check {
    margin-left: auto;
    letter-spacing: 0.01em;
    padding: 8px 0;
  }
`;

export const ChooseNwComing = styled.div`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #72706e;
`;

export const ChooseNwIcon = styled.div`
  background: #efe8e6;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  &.eth {
    padding: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const Notification = styled.div`
  position: fixed;
  left: 50%;
  top: 24px;
  transform: translateX(-50%);
  background: #000000;
  border-radius: 24px;
  color: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
  z-index: 2000;
  gap: 16px;
  width: 462px;
  max-width: calc(100% - 32px);
  opacity: 0;
  visibility: hidden;
  transition: 200ms ease-out;
  img {
    width: 64px;
    height: 64px;
  }
  &.shown {
    visibility: visible;
    opacity: 1;
  }
`;

export const Form = styled.div`
  .inputfield {
    cursor: text;
  }
  .input-container {
    width: 100%;
  }
  && {
    display: flex;
    align-items: center;
    gap: 8px;
    .icon.button {
      width: 64px;
      padding: 2px;
    }
    @media (max-width: 769px) {
      width: 100%;
      text-align: left;
    }
  }
`;

export const Subscribe = styled.div`
  border-radius: var(--rounding-radius-xxl, 32px);
  padding: var(--spacing-space-24, 24px) var(--spacing-space-24, 24px)
    var(--spacing-space-24, 24px) var(--spacing-space-40, 40px);
  display: flex;
  align-items: center;
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));

  button.icon {
    background: #9fe;
    &:hover {
      background: var(--fill-accent-primary-hover, #defef9);
    }
  }
  & > * {
    flex: 1 1 50%;
  }
  .header {
    color: var(--text-primary-on-dark, #fff);
  }
  .button {
    max-width: 64px;
    padding: 2px;
  }
  div.input__area {
    display: flex;
    align-items: center;
    border-radius: var(--rounding-radius-m, 16px);
    background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  }
  .input__area .input__hint {
    color: var(--invert-secondary, rgba(242, 237, 235, 0.48));
  }
  .input-container {
    color: #fff;
  }
  @media (max-width: 769px) {
    flex-direction: column;
    padding: 32px 24px 24px;
    gap: 32px;
    align-items: center;
    & > * {
      text-align: center;
    }
  }
`;
